import { Button } from "antd";
import { CheckCircle2, Clock, Loader2, RefreshCw, XCircle } from "lucide-react";

import type { EntitySyncPhase } from "../hooks/useEntitySync";

/** 工商同步底栏按钮 props */
export interface SyncFooterButtonProps {
  entityId?: string;
  syncPhase: EntitySyncPhase;
  getSyncRemaining: (id: string) => number;
  onSync: () => void;
}

/** 格式化冷却倒计时为「X天X时X分X秒」 */
const formatCooldown = (remainingMs: number): string => {
  const days = Math.floor(remainingMs / (24 * 60 * 60 * 1000));
  const hours = Math.floor((remainingMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);
  return `${days}天${hours}时${minutes}分${seconds}秒`;
};

/** 工商同步按钮：同步中 / 成功 / 失败 / 冷却 / 可点击 */
export const SyncFooterButton = ({
  entityId,
  syncPhase,
  getSyncRemaining,
  onSync,
}: SyncFooterButtonProps) => {
  if (syncPhase === "syncing") {
    return (
      <Button disabled icon={<Loader2 className="w-3.5 h-3.5 animate-spin" />}>
        同步拉取中...
      </Button>
    );
  }
  if (syncPhase === "success") {
    return (
      <Button
        disabled
        className="text-green-600! border-green-200! bg-green-50!"
        icon={<CheckCircle2 className="w-3.5 h-3.5" />}
      >
        同步成功
      </Button>
    );
  }
  if (syncPhase === "failed") {
    return (
      <Button
        disabled
        className="text-red-500! border-red-200! bg-red-50!"
        icon={<XCircle className="w-3.5 h-3.5" />}
      >
        同步失败
      </Button>
    );
  }
  if (syncPhase === "cooldown" && entityId) {
    const remaining = getSyncRemaining(entityId);
    return (
      <Button disabled icon={<Clock className="w-3.5 h-3.5" />}>
        工商同步（{formatCooldown(remaining)}）
      </Button>
    );
  }
  return (
    <Button icon={<RefreshCw className="w-3.5 h-3.5" />} onClick={onSync}>
      工商同步
    </Button>
  );
};
